var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"backdrop"}},[(_vm.backdropShow)?_c('div',{staticClass:"backdrop",on:{"click":_vm.backdropClose}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }